<template>
  <div>
    <div class="header">
      <h1 class="page-title">订单统计</h1>
    </div>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="block">
          <span>日期：</span>

          <el-date-picker
            v-model="value2"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="date()"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <button class="searchBtn" @click="selectStatus()">搜索</button>
          <div class="sy-zongj" v-if="JSON.stringify(reportList)!='[]'">
            <i>
              总商品金额:
              <b>{{reportList.count.goods_price+' 元'}}</b>
            </i>
            <i>
              总运费:
              <b>{{reportList.count.shipping_fee+' 元'}}</b>
            </i>
            <i>
              总计:
              <b>{{reportList.count.total_price+' 元'}}</b>
            </i>
            <i>
              总重量:
              <b>{{reportList.count.product_weight+' kg'}}</b>
            </i>
            <i>
              总订单条数:
              <b>{{reportList.count.num+'条'}}</b>
            </i>
            <a
              :href="baseUrl+`/api/order/daysorder/explode/1/uid/${uId}${queryInfo.mindate==''?'':`/mindate/${queryInfo.mindate}`}${queryInfo.maxdate==''?'':`/maxdate/${queryInfo.maxdate}`}`"
              class="ex_btn"
            >导出列表</a>
            <a
              :href="baseUrl+`/api/order/daysorderxq/explode/1/uid/${uId}${queryInfo.mindate==''?'':`/mindate/${queryInfo.mindate}`}${queryInfo.maxdate==''?'':`/maxdate/${queryInfo.maxdate}`}`"
              class="ex_btn"
            >导出明细</a>
          </div>
        </div>
      </div>

      <div class="main">
        <el-table
          v-loading="loading"
          :data="reportList.info"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column :resizable="false" type="index" width="50" label="序 号"></el-table-column>
          <el-table-column :resizable="false" prop="daytime" label="日期"></el-table-column>
          <el-table-column :resizable="false" prop="num" label="当日订单条数"></el-table-column>
          <el-table-column :resizable="false" prop="goods_price" label="商品价格"></el-table-column>
          <el-table-column :resizable="false" prop="packprice" label="包装费"></el-table-column>
          <el-table-column :resizable="false" prop="shipping_fee" label="运费总计"></el-table-column>
          <el-table-column :resizable="false" prop="product_weight" label="总重量"></el-table-column>
         
          <el-table-column :resizable="false" prop="total_price" label="价格总计"></el-table-column>
          <el-table-column :resizable="false" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showDialog(scope.row.daytime)">查看明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="当天明细" :visible.sync="dialogVisible" width="75%" @close="handleClose">
          <a
            :href="baseUrl+`/api/order/daysorderxq/explode/1/date/${datee}/uid/${uId}`"
            id="exportTable"
          >导出excel</a>
          <div class="totalInfo">
            <span>
              总商品金额:
              <i>{{totalInfo.goods_price + '元'}}</i>
            </span>
            <span>
              总运费:
              <i>{{totalInfo.shipping_fee + '元'}}</i>
            </span>
            <span>
              总计:
              <i>{{totalInfo.total_price + '元'}}</i>
            </span>
            <span>
              总重量:
              <i>{{totalInfo.total_weight + 'kg'}}</i>
            </span>
            <span>
              总订单条数:
              <i>{{totalInfo.num + '条'}}</i>
            </span>
          </div>
          <table
            cellpadding="0"
            cellspacing="0"
            class="orderTab"
            v-loading="loading1"
            style=" overflow: auto; table-layout: fixed;;"
          >
            <thead>
              <td width="30">序号</td>
              <th width="85">订单号</th>
              <th width="55">子订单</th>
              <th>包</th>
              <th width="90">产品名称</th>
              <th width="160">规格</th>
              <th width="200">文件名</th>
              <th width="70">产品金额</th>
              <th width="70">包装费</th>
              <th width="50">运 费(元)</th>
              <th width="40">重 量</th>
              <th width="70">应付金额</th>
              <th width="70">实付金额</th>
              <th width="50">订单状态</th>
              <th width="90">物流方式</th>
              <th width="130">时间</th>
            </thead>
            <template v-if="JSON.stringify(tbData) !='[]'">
              <tbody
                :class="[item.length==1?'':'orange']"
                v-for="(item,index) in tbData"
                :key="index"
              >
                <!-- 未合包布局 -->

                <template v-if="item.length==1">
                  <tr>
                    <td>{{indexMethod(index)}}</td>
                    <td width="85">{{item[0].order_no}}</td>
                    <td></td>
                    <td>1</td>
                    <td>{{item[0].product_name}}</td>
                    <td>{{item[0].title}}</td>
                    <td>{{item[0].file}}</td>
                    <td>{{item[0].goods_price}}</td>
                     <td>{{item[0].packprice}}</td>
                    <td>{{item[0].total_shipping_fee}}</td>
                    <td>{{item[0].total_weight + 'kg'}}</td>
                    <td>{{item[0].total_price}}</td>
                    <td>{{item[0].realy_price}}</td>
                    <td>{{item[0].status_str}}</td>
                    <td>{{item[0].express_name}}</td>
                    <td>{{item[0].createtime|dateFormat}}</td>
                  </tr>
                </template>
                <!-- 合包布局 -->
                <template v-else>
                  <template v-for="(item1,index1) in item">
                    <tr v-if="index1==0" :key="index1">
                      <td :rowspan="item.length">{{indexMethod(index)}}</td>
                      <td :rowspan="item.length">{{item1.order_no}}</td>
                      <td>{{item1.pack}}</td>
                      <td :rowspan="item.length">{{item1.packnum}}</td>
                      <td>{{item1.product_name}}</td>
                      <td>{{item1.title}}</td>
                      <td>{{item[0].file}}</td>
                      <td>{{item1.goods_price}}</td>
                       <td>{{item1.packprice}}</td>
                      <td :rowspan="item.length">{{item[0].total_shipping_fee}}</td>
                      <td :rowspan="item.length">{{item[0].total_weight + 'kg'}}</td>
                      <td :rowspan="item.length">{{item[0].total_price}}</td>
                      <td :rowspan="item.length">{{item[0].realy_price}}</td>
                      <td>{{item1.status_str}}</td>
                      <td :rowspan="item.length">{{item1.express_name}}</td>
                      <td :rowspan="item.length">{{item1.createtime|dateFormat}}</td>
                    </tr>
                    <tr v-else>
                      <td>{{item1.pack}}</td>
                      <td>{{item1.product_name}}</td>
                      <td>{{item1.title}}</td>
                      <td>{{item[0].file}}</td>
                      <td>{{item1.goods_price}}</td>
                      <td>{{item1.status_str}}</td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </template>
            <div class="zw" v-else>暂无数据</div>
          </table>

          <el-pagination
            style="margin-left:600px"
            :hide-on-single-page="true"
            @current-change="handleCurrentChange1"
            background
            layout="prev, pager, next"
            :total="ptotal"
            :current-page.sync="currentPage"
          ></el-pagination>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
        :total="page_count"
        :hide-on-single-page="true"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import JsonExcel from 'vue-json-excel'
export default {
  components: {
    downloadExcel: JsonExcel
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      value2: '',
      loading: true,
      reportList: [],
      queryInfo: {
        token: window.localStorage.getItem('token'),
        mindate: '',
        maxdate: '',
        page: 1
      },
      page_count: 1,
      dialogVisible: false,
      tbData: [],
      ptotal: 0,
      ppage: 1,
      token: window.localStorage.getItem('token'),
      datee: '',
      currentPage: 1,
      totalInfo: {},
      loading1: true,
      baseUrl: '',
      uId: ''
    }
  },
  created() {
    const url = window.location.host
    this.baseUrl = !url.includes('192')
      ? 'http://' + url
      : 'https://www.yunshanyin.net'
    if (window.localStorage.getItem('u')) {
      let u = window.localStorage.getItem('u')
      this.uId = JSON.parse(u).id
    }

    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.queryReportList()
    this.getYue()
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    indexMethod(index) {
      if (this.ppage == 1) {
        return index + 1
      }
      if (index + 1 == 10) {
        return this.ppage + '' + 0
      }
      return this.ppage - 1 + '' + (index + 1)
    },
    handleClose() {
      this.currentPage = 1
    },
    async showDialog(date) {
      this.ppage = 1
      this.datee = date
      this.dialogVisible = true
      this.queryDaysList()
    },

    handleCurrentChange1(value) {
      this.ppage = value
      this.queryDaysList()
    },
    async queryDaysList() {
      this.loading1 = true
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('date', this.datee)
      param.append('page', this.ppage)
      // param.append('explode', 1)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/order/daysorderxq',
        data: param
      })

      this.loading1 = false
      if (res.code == 1) {
        this.tbData = res.data.data
        this.ptotal = res.data.page_count * 10
        this.totalInfo = res.data.total
      }
    },
    handleCurrentChange(val) {
      this.queryInfo.page = val
      this.queryReportList()
    },
    date() {
      if (this.value2 != null) {
        this.queryInfo.mindate = this.value2[0] + ' 00:00:00'
        this.queryInfo.maxdate = this.value2[1] + ' 23:59:59'
      } else {
        this.queryInfo.mindate = ''
        this.queryInfo.maxdate = ''
      }
    },
    selectStatus() {
      this.queryInfo.page = 1
      this.queryReportList()
    },
    //   查询报表数据
    async queryReportList() {
      this.reportList = []
      let param = new URLSearchParams()
      for (let key in this.queryInfo) {
        param.append(key, this.queryInfo[key])
      }
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/order/daysorder',
        data: param
      })
      if (res.code == 1) {
        this.reportList = res.data
        this.reportList.info = this.reportList.info
        this.page_count = res.data.page_count * 10
        this.loading = false
        let countprice = 0
      }
    }
  },
  mounted() {
    $('.menuItems').on('click', 'li', function() {
      $(this)
        .children('a')
        .css({ color: '#a77c5a', 'border-left': '3px solid #a77c5a' })
      $(this)
        .siblings('li')
        .children('a')
        .css({ color: '#666', 'border-left': '3px solid #ccc' })
    })
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.main {
  .orange {
    background-color: #f0fff0;
    border-bottom: 2px solid #a77c5a;
  }
  .orderTab {
    position: relative;
    height: 80px;
    th {
      padding: 10px 5px;
      background-color: #fafafa;
    }

    td {
      padding: 10px;
      border: 1px solid #eee;
      font-size: 12px;
      color: #666;
      word-break: break-all;
    }
    .zw {
      font-size: 18px;
      color: #666;
      text-align: center;
      position: absolute;
      top: 50px;
      right: 750px;
    }
  }
}
.el-card {
  ul {
    li {
      float: left;
      padding: 0px 15px;
      margin-right: 30px;
      height: 30px;
      cursor: pointer;
      a {
        padding-left: 5px;
        display: block;
        height: 15px;
        line-height: 15px;
        border-left: 3px solid #ccc;
        transition: all 0.3s;
      }
      a:hover {
        border-left: 3px solid #a77c5a;
      }
    }
  }
  .block {
    position: relative;
    margin-top: 30px;
    span {
      margin-right: 10px;
      color: #666;
    }
    .searchBtn {
      padding: 8px 20px;
      margin-top: 5px;
      margin-left: 15px;
      color: #fff;
      background: #a77c5a;
      border-radius: 3px;
    }
    .sy-zongj {
      position: absolute;
      top: 13px;
      left: 550px;
      font-size: 16px;
      i {
        margin-right: 15px;
        b {
          color: #e83030;
        }
      }
    }
  }
  .el-pagination {
    margin: 40px 0 0 700px;
  }
}
.totalInfo {
  span {
    margin-right: 20px;
    font-size: 20px;
  }
}
#exportTable {
  background-color: #409eff;
  padding: 1px;
  border-radius: 6px;
  color: #fff;
  text-align: center;
  z-index: 999;
  top: 60px;
  right: 60px;
}

.ex_btn {
  display: inline-block;
  background-color: #409eff;
  width: 80px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  margin-left: 30px;
  border-radius: 6px;
  padding: 1px 3px;
}
</style>